import { createSelector } from '@reduxjs/toolkit';
export const typesSelector = ({
  types
}) => types;
export const conditionTypesSelector = createSelector(typesSelector, ({
  conditionTypes
}) => conditionTypes);